import { DynamicScopeTables } from './DynamicScopeTables';
import { FileSearchOutlined } from '@ant-design/icons';
import { InitiativeExportButton } from './InitiativeExportButton';
import { InitiativeSection } from '../general';
import { NoData } from '@ui/NoData';
import React from 'react';
import { COPY_SPECIFIC, MESSAGES_COPY } from '@sonar-software/sonar-ts-constants';
import { useInitiativeScopeCounts, useQueryParams } from '@hooks';
export const ScopeSection = ({ initiativeId }) => {
    const { counts, totalCount } = useInitiativeScopeCounts(initiativeId);
    const { queryParams, updateParams } = useQueryParams({
        defaultParams: {
            filters: '',
            ordering: ''
        }
    });
    return (React.createElement(InitiativeSection, { count: totalCount, headerExtra: React.createElement(InitiativeExportButton, { disabled: !totalCount, filters: queryParams.filters, initiativeId: initiativeId }), icon: React.createElement(FileSearchOutlined, null), id: 'initiative-scope', title: COPY_SPECIFIC.SCOPE },
        !totalCount &&
            React.createElement(NoData, { description: React.createElement("div", { className: 'initiative-scope-table-empty-message' }, MESSAGES_COPY.THIS_INITIATIVE_HAS_NO_SCOPE) }),
        Boolean(totalCount) && React.createElement(DynamicScopeTables, { counts: counts, initiativeId: initiativeId, queryParams: queryParams, updateParams: updateParams })));
};
